import { render, staticRenderFns } from "./TeamTab.vue?vue&type=template&id=63b2790c"
import script from "./TeamTab.vue?vue&type=script&lang=js"
export * from "./TeamTab.vue?vue&type=script&lang=js"
import style0 from "./TeamTab.vue?vue&type=style&index=0&id=63b2790c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports